import generateUuid from '@/tools/generate-uuid'

export const UPDATE_TRIGGERS = {
  CHANGE_PAGINATION: 'CHANGE_PAGINATION',
  CHANGE_TERM: 'CHANGE_TERM',
  CHANGE_FILTERS: 'CHANGE_FILTERS',
  CHANGE_SORT: 'CHANGE_SORT',
  NAVIGATE_HISTORY: 'NAVIGATE_HISTORY',
  CHANGE_DEPARTMENT: 'CHANGE_DEPARTMENT',
  INITIAL_LOAD: 'INITIAL_LOAD',
  CHANGE_STATIC_OPTIONS: 'CHANGE_STATIC_OPTIONS',
  RELOAD: 'RELOAD',
  RESET: null
}

export const UPDATE_TRIGGERS_THAT_KEEP_AGGREGATIONS = [
  UPDATE_TRIGGERS.CHANGE_PAGINATION,
  UPDATE_TRIGGERS.CHANGE_SORT
]

export const AUTO_LOAD_SEARCH_ID = {
  get_uuid: () => {
    const uuid = generateUuid()
    const timestamp = new Date().getTime()

    return uuid.concat('-', timestamp)
  }
}

export const PREVIOUS_PAGES_CURSORS_LIMIT = 4

export const RECENTLY_SEARCHED_TERMS_STORAGE_KEY = 'recentlySeachedTerms'

export const MAX_RECENTLY_SEARCHED_TERMS = 6
